import axiosInstance from '../../utils/axiosInstance';
import endpoints from '../../utils/endpoints';
import serializeStrapiParams from '../../utils/serializeStrapiParams';

// Strapi locale updates must use the locale query param and exclude
// the locale field from the request body.
const buildLocalePayload = (data) => {
  const { locale: _locale, ...rest } = data || {};

  return {
    data: rest,
  };
};

const find = async (query) => {
  const { data } = await axiosInstance.get(endpoints.objects(), {
    params: query,
    paramsSerializer: (params) => {
      const pairs = serializeStrapiParams(params);
      return pairs.join('&');
    },
  });
  return data;
};

const findOne = async (id, locale = 'lt-LT') => {
  const { data } = await axiosInstance.get(
    `${endpoints.objects(id)}?locale=${locale}`
  );
  return data;
};

const create = async (data, locale = 'lt-LT') => {
  const payload = {
    data: {
      ...data,
      locale,
    },
  };

  const { data: object } = await axiosInstance.post(endpoints.objects(), payload);
  return object;
};

const update = async (id, data, locale = 'lt-LT') => {
  const payload = buildLocalePayload(data);
  const { data: object } = await axiosInstance.put(
    `${endpoints.objects(id)}?locale=${locale}`,
    payload
  );
  return object;
};

const remove = async (id) => {
  const { data: object } = await axiosInstance.delete(endpoints.objects(id));
  return object;
};

const createLocalization = async (id, data, locale) => {
  const endpoint = endpoints.objects(id);
  const url = `${endpoint}?locale=${locale}`;

  const requestData = buildLocalePayload(data);
  
  try {
    const response = await axiosInstance.put(url, requestData);
    return response.data;
  } catch (error) {
    const errorInfo = {
      url,
      id,
      locale,
      status: error.response?.status,
      statusText: error.response?.statusText,
      errorData: error.response?.data,
    };
    
    console.error('Error creating localization:', errorInfo);
    
    // If 404, the endpoint might not exist or i18n isn't properly configured
    if (error.response?.status === 404) {
      const errorMessage = 
        `Failed to create ${locale} localization: Endpoint not found (404). ` +
        `URL: ${url}. ` +
        `Please verify: 1) i18n plugin is installed and enabled, ` +
        `2) Strapi server has been restarted after enabling i18n, ` +
        `3) Object content type has i18n enabled in schema.`;
      throw new Error(errorMessage);
    }
    
    throw error;
  }
};

const client = { find, findOne, create, update, remove, createLocalization };

export default client;
